(function () {
  'use strict';

  var root = document.querySelector('[data-wheel-builder-checkout]');
  if (!root) return;

  var message = root.querySelector('[data-wheel-builder-checkout-message]');
  var retryButton = root.querySelector('[data-wheel-builder-checkout-retry]');
  var buildId = new URLSearchParams(window.location.search).get('build') || '';
  var serviceBaseUrl = root.getAttribute('data-service-base-url') || '';
  var completedKey = 'w9WheelBuilderCheckoutComplete:' + buildId;
  var BUILD_ID_RE = /^[A-Za-z0-9_-]{32,128}$/;

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function routeUrl(path) {
    return new URL(String(path || '').replace(/^\/+/, ''), window.location.origin + routeRoot()).href;
  }

  function setMessage(text) {
    if (message) message.textContent = text;
  }

  function showRetry(text) {
    setMessage(text);
    if (retryButton) retryButton.hidden = false;
  }

  function hideRetry() {
    if (retryButton) retryButton.hidden = true;
  }

  function checkoutUrl() {
    return routeUrl('checkout');
  }

  function normalizeServiceBaseUrl(value) {
    if (!value) throw new Error('Wheel builder service URL is not configured on this page.');
    var parsed = new URL(value, window.location.href);
    if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') {
      throw new Error('Wheel builder service URL is invalid.');
    }
    parsed.pathname = parsed.pathname.replace(/\/$/, '/') || '/';
    parsed.search = '';
    parsed.hash = '';
    return parsed.href;
  }

  function buildUrl() {
    var url = new URL('api/wheel-builder/builds/' + encodeURIComponent(buildId), normalizeServiceBaseUrl(serviceBaseUrl));
    return url.href;
  }

  function objectHasWheelBuilder(value, target) {
    if (!value || typeof value !== 'object') return false;
    if (value._wheelBuilder === target) return true;
    if (value.properties && value.properties._wheelBuilder === target) return true;
    return Object.keys(value).some(function (key) {
      var child = value[key];
      if (!child || typeof child !== 'object') return false;
      if (Array.isArray(child)) return child.some(function (item) { return objectHasWheelBuilder(item, target); });
      return objectHasWheelBuilder(child, target);
    });
  }

  function cartHasBuild(cart, target) {
    if (!cart || !target) return false;
    var items = Array.isArray(cart.items) ? cart.items : [];
    return items.some(function (item) { return objectHasWheelBuilder(item, target); });
  }

  async function fetchJson(url, options) {
    var response = await fetch(url, options || {});
    var payload = await response.json().catch(function () { return null; });
    if (!response.ok) {
      var detail = payload && (payload.error || payload.description || payload.message);
      throw new Error(detail || ('Request failed: ' + response.status));
    }
    return payload;
  }

  async function fetchCart() {
    return fetchJson(routeUrl('cart.js'), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    });
  }

  async function confirmBuildInCart() {
    var cart = await fetchCart();
    return cartHasBuild(cart, buildId);
  }

  async function fetchBuild() {
    return fetchJson(buildUrl(), {
      mode: 'cors',
      credentials: 'omit',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    });
  }

  async function addCartItems(cartPayload) {
    return fetchJson(routeUrl('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(cartPayload)
    });
  }

  async function refreshCartTransform(cartPayload) {
    var attributes = Object.assign({}, cartPayload && cartPayload.attributes);
    attributes._w9WheelBuilderTransformRefresh = buildId + ':' + Date.now();

    return fetchJson(routeUrl('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: attributes
      })
    });
  }

  async function run() {
    hideRetry();

    if (!BUILD_ID_RE.test(buildId)) {
      showRetry('This wheel build link is invalid. Please return to the wheel builder and try again.');
      return;
    }

    setMessage('Checking your Warp 9 cart…');
    if (window.sessionStorage.getItem(completedKey) === 'true') {
      if (await confirmBuildInCart()) {
        window.location.assign(checkoutUrl());
        return;
      }
      window.sessionStorage.removeItem(completedKey);
    }

    if (await confirmBuildInCart()) {
      window.sessionStorage.setItem(completedKey, 'true');
      window.location.assign(checkoutUrl());
      return;
    }

    setMessage('Retrieving your validated wheel build…');
    var build = await fetchBuild();
    if (!build || !build.cart || !Array.isArray(build.cart.items) || !build.cart.items.length) {
      throw new Error('The wheel build payload was empty. Please return to the wheel builder and try again.');
    }

    if (build.buildId !== buildId) {
      throw new Error('The wheel build response did not match this checkout link.');
    }

    setMessage('Adding your wheel components to the Warp 9 cart…');
    try {
      await addCartItems(build.cart);
      setMessage('Preparing your wheel bundle…');
      await refreshCartTransform(build.cart);
      window.sessionStorage.setItem(completedKey, 'true');
      setMessage('Wheel added. Redirecting to checkout…');
      window.location.assign(checkoutUrl());
      return;
    } catch (error) {
      setMessage('Checking whether the cart update completed…');
      if (await confirmBuildInCart()) {
        window.sessionStorage.setItem(completedKey, 'true');
        window.location.assign(checkoutUrl());
        return;
      }
      throw new Error(error.message || 'Shopify could not add the wheel components. Please try again.');
    }
  }

  if (retryButton) {
    retryButton.addEventListener('click', function () {
      run().catch(function (error) {
        console.error('[wheel-builder-checkout]', error);
        showRetry(error.message || 'Checkout preparation failed. Please try again.');
      });
    });
  }

  run().catch(function (error) {
    console.error('[wheel-builder-checkout]', error);
    showRetry(error.message || 'Checkout preparation failed. Please try again.');
  });
})();
